import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_publication_list.svg';
import SVG from "react-inlinesvg";

const IconPublicationListChart = () => (

    <SVG src={icon} height={40} style = {{ marginTop: 10}} />

);
export default IconPublicationListChart;